export const OilSupplierMutationKeys = {
  CREATE_OIL_SUPPLIER: "oil-supplier-create",
  UPDATE_OIL_SUPPLIER: "oil-supplier-update",
  DELETE_OIL_SUPPLIER: "oil-supplier-delete",
} as const;
